import { render } from "./PButton.vue?vue&type=template&id=6c912484&scoped=true&ts=true"
import script from "./PButton.vue?vue&type=script&lang=ts"
export * from "./PButton.vue?vue&type=script&lang=ts"

import "./PButton.vue?vue&type=style&index=0&id=6c912484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c912484"]])

export default __exports__